import React, { useState } from "react";
import { Link } from "react-router-dom";
import videoData from "./videoData.json"; // Adjust the path as needed

const Videos = () => {
  const [selectedTopic, setSelectedTopic] = useState("");
  const [playingVideo, setPlayingVideo] = useState(null); // Track which video is currently playing

  const videoTopics = ["Internal Audits", "Risk Management", "Compliance"];
  
  // Use the imported videoData array as videos
  const videos = videoData;

  const filteredVideos = videos.filter(
    (video) => !selectedTopic || video.topic === selectedTopic
  );

  const handlePlay = (videoName) => {
    // Toggle playing state: if the video is already playing, stop it; otherwise, play it.
    setPlayingVideo(videoName === playingVideo ? null : videoName);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Videos</h2>

      {/* Filter Section */}
      <div className="mb-6">
        <label htmlFor="video-topic-filter" className="font-medium text-gray-600">
          Filter by Topic
        </label>
        <select
          id="video-topic-filter"
          className="w-full mt-2 p-2 border rounded-md"
          value={selectedTopic}
          onChange={(e) => setSelectedTopic(e.target.value)}
        >
          <option value="">All Topics</option>
          {videoTopics.map((topic, index) => (
            <option key={index} value={topic}>
              {topic}
            </option>
          ))}
        </select>
      </div>

      {/* Video Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredVideos.map((video, index) => (
          <div
            key={index}
            className="bg-gray-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-md"
          >
            {playingVideo === video.name ? (
              // Show video player if this video is playing
              <video
                className="rounded-md mb-4"
                src={video.videoUrl}
                controls
                autoPlay
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              // Show thumbnail if the video is not playing
              <div
                className="bg-gray-400 h-40 w-full rounded-md mb-4 cursor-pointer"
                style={{
                  backgroundImage: `url(${video.thumbnail})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                onClick={() => handlePlay(video.name)}
              ></div>
            )}
            <h3 className="text-lg font-semibold text-gray-700">{video.name}</h3>
            {/* Link to navigate to the video details page */}
            <Link
              to={`/videos/${video.slug}`}
              className="mt-2 text-blue-500 hover:underline"
            >
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Videos;
